<template>
  <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="default"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        ref="form"
        :data-url="
          selectedUrl
            ? `/accreditations/sampling/${inputs.id}`
            : '/accreditations/sampling'
        "
      >
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>Organización</label>
              <multiselect
                v-model="inputs.org_id"
                :options="orgs"
                placeholder="Seleccione una opción"
                label="value"
              ></multiselect>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label>Categoría</label>
              <multiselect v-model="inputs.level3" :options="scopes.level3" placeholder="Seleccione una opción" label="value">
              </multiselect>
            </div>
          </div>
          
          <div class="col-12">
            <div class="form-group">
              <label>Campo de ensayo</label>
              <multiselect v-model="inputs.level4" :options="scopes.level4" placeholder="Seleccione una opción" label="value">
              </multiselect>
            </div>
          </div>

          <div class="col-12 mb-5">
            <div class="form-group">
              <label>PRODUCTO O MATERIAL A MUESTREAR</label>
              <!--              <app-input-->
              <!--                type="textarea"-->
              <!--                v-model="inputs.product"-->
              <!--                placeholder="Ingrese el producto o material a muestrear"-->
              <!--                :required="true"-->
              <!--              />-->
              <quill-editor v-model="inputs.product" :options="editorOption" />
            </div>
          </div>
          <br /><br />
          <br />
          <div class="col-12 mt-5 mb-5">
            <div class="form-group">
              <label
                >MÉTODO INTERNO DE MUESTREO (5)</label
              >
              <!--              <app-input-->
              <!--                type="textarea"-->
              <!--                v-model="inputs.process"-->
              <!--                :required="true"-->
              <!--                placeholder="Ingrese el procedimiento de muestreo"-->
              <!--              />-->
              <quill-editor v-model="inputs.process" :options="editorOption" />
            </div>
          </div>

          <br />
          <br />
          <br />

          <div class="col-12 mt-5 mb-5">
            <div class="form-group">
              <label
                >MÉTODO DE REFERENCIA DEL MUESTREO
                (revisión/edición) (5)</label
              >
              <!--              <app-input-->
              <!--                type="textarea"-->
              <!--                v-model="inputs.method"-->
              <!--                placeholder="Ingrese los métodos de ensayo a los que aplica"-->
              <!--                :required="true"-->
              <!--              />-->
              <quill-editor v-model="inputs.method" :options="editorOption" />
            </div>
          </div>

          <br />
          <br />
          <br />

          <div class="col-12 mt-5 mb-5">
            <div class="form-group">
              <label>MÉTODOS DE ENSAYO A LOS QUE APLICA (Procedimiento interno y/o
                método de referencia)</label>
              <!--              <app-input-->
              <!--                type="textarea"-->
              <!--                v-model="inputs.method"-->
              <!--                placeholder="Ingrese los métodos de ensayo a los que aplica"-->
              <!--                :required="true"-->
              <!--              />-->
              <quill-editor v-model="inputs.test_methods" :options="editorOption" />
            </div>
          </div>

          <br />
          <br />
          <br />

          <div class="col-12 mt-5 mb-5">
            <div class="form-group">
              <label>Justificación</label>
              <quill-editor v-model="inputs.observation" :options="editorOption" />
            </div>
          </div>
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        @click.prevent="submit"
        :disabled="disabledSubmit"
      >
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import { quillEditor } from "vue-quill-editor";
import Multiselect from "vue-multiselect";

export default {
  mixins: [FormMixin, ModalMixin],
  components: { Multiselect, quillEditor },
  props: {
    tableId: String,
    selectedUrl: String,
    accAppId: Number,
    statusId: Number,
  },
  data() {
    return {
      scopes: {
        level3: [],
        level4: [],
      },
      editorOption: {
        placeholder: "Inserte el texto aquí..",
        modules: {
          toolbar: [
            [{ size: ["small", false, "large", "huge"] }],
            [
              "bold",
              "italic",
              "underline",
              "strike",
              { color: [] },
              { background: [] },
            ],
            [{ align: [] }],
            [
              { list: "ordered" },
              { list: "bullet" },
              { indent: "-1" },
              { indent: "+1" },
            ],
            ["clean"],
          ],
        },
      },
      preloader: false,
      inputs: {},
      modalId: "add-edit-modal",
      disabledSubmit: false,
      orgs: [],
    };
  },
  computed: {
    title() {
      return this.selectedUrl ? "Editar" : "Registrar";
    },
  },
  created() {
    this.getData();
    if (this.selectedUrl) {
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      const tmp = {
        ...this.inputs,
        acc_app_id: this.accAppId,
        status_id: this.statusId,
      };
      tmp.org_id = tmp.org_id ? tmp.org_id.id : null;
      tmp.level3= this.inputs.level3.id;
      tmp.level4= this.inputs.level4.id;

      this.disabledSubmit = true;
      this.save(tmp);
    },

    afterJsValidationFail() {
      this.disabledSubmit = false;
    },

    afterSuccess(response) {
      // this.$toastr.s(response.data.message);
      if (this.inputs.id) {
        this.$toastr.s(this.$t("updated_success"));
      } else {
        this.$toastr.s(this.$t("created_success"));
      }
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      this.inputs = response.data;
      this.inputs.org_id = response.data.org;
      if (!this.inputs.org_id) {
        this.inputs.org_id = { id: null, value: "Matriz" };
      }
      this.inputs.level3 = response.data.level_3;
      this.inputs.level4 = response.data.level_4;
      this.preloader = false;
    },

    getData() {
      this.preloader = true;

      this.axiosGet(
        `request/options?accAppId=${this.accAppId}`
      )
        .then((response) => {
          if (response.status == 200) {
            const {
              data: { scopes, orgs },
            } = response;
            this.scopes = scopes;
            this.orgs = [{ id: null, value: "Matriz" }, ...orgs];
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
  },
};
</script>
